<template>
  <div :data-component-name="$options.name">
    <b-row>
      <b-col class="col-12 d-flex justify-content-center">
        <img v-lazy="jel_getFichierSrc(content.image)" class="image" :alt="content.titre" />
      </b-col>
      <b-col class="col-12 d-flex justify-content-center">
        <p class="mb-2">
          <span class="titre graphik_bold" v-html="content.titre" />
        </p>
      </b-col>
      <b-col class="col-12 d-flex justify-content-center">
        <template v-if="content.sousTitre">
          <p v-html="content.sousTitre"></p>
        </template>
      </b-col>
      <b-col class="col-12 d-flex justify-content-center">
        <div class="h-50 d-inline-block texte text-center" v-html="content.texte" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'MediaImageImg50tit10txt40',
  props: { content: { type: Object, required: true } },
  data() {
    return {};
  },
  computed: {
    classObject() {
      return {
        rounded: this.content.coinArrondi,
      };
    },
    styleObject() {
      return {
        'background-color':
          this.content.fondCouleur?.field === 'couleurEdit'
            ? this.content.fondCouleur.secBgThemeColor
            : null,
      };
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.row {
  background-position: center;
  background-repeat: no-repeat;
}
.row.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}

.container {
  text-align: center;
  color: black;
}
.image {
  width: 60%;
}

@media only screen and (min-width: 375px) and (max-width: 500px) {
  .image {
    width: 60%;
  }
}

.titre {
  @include ms-respond(font-size, 2);
}

.texte {
  @include ms-respond(font-size, 0);
}
</style>
